/**
 * Cart Attribute Cleanup
 * Removes unwanted VFitz attributes (Sources 5, 6, 7)
 * Keeps only: Vehicle_Make, Vehicle_Year, Vehicle_Model, Vehicle_SubModel, VIN
 */

(function() {
  'use strict';
  
  // Attributes to remove
  const ATTRIBUTES_TO_REMOVE = [
    'Vechile Info',  // Source 5 (typo)
    'Vehicle Info'   // Source 6 (correct spelling)
    // Source 7: [Item#X] - will be removed with pattern matching
  ];
  
  // Clean cart attributes
  async function cleanCartAttributes() {
    try {
      // Get current cart
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      if (!cart.attributes) return;
      
      // Build cleanup object
      const cleanup = {};
      let needsCleanup = false;
      
      // Remove specific attributes
      ATTRIBUTES_TO_REMOVE.forEach(attr => {
        if (cart.attributes[attr] !== undefined) {
          cleanup[attr] = null;
          needsCleanup = true;
        }
      });
      
      // Remove [Item#X] attributes (Source 7)
      Object.keys(cart.attributes).forEach(key => {
        if (key.match(/^\[Item#\d+\]/)) {
          cleanup[key] = null;
          needsCleanup = true;
        }
      });
      
      // Update cart if cleanup needed
      if (needsCleanup) {
        console.log('Cleaning cart attributes:', Object.keys(cleanup));
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({attributes: cleanup})
        });
      }
    } catch (error) {
      console.error('Cart cleanup error:', error);
    }
  }
  
  // Run cleanup on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanCartAttributes);
  } else {
    cleanCartAttributes();
  }
  
  // Also run when cart updates
  if (typeof Shopify !== 'undefined' && Shopify.theme) {
    document.addEventListener('cart:updated', cleanCartAttributes);
  }
  
  // Run after VFitz updates
  window.addEventListener('vfitzCustomSearchSubmit', () => {
    setTimeout(cleanCartAttributes, 500);
  });
  
})();
